import * as React from "react";
import { Divider } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";

interface Props {}
export const AddonAzureWorkloadIdentity: React.FC<Props> = ({}) => {
  const isEnabled = useCpFormValue(`addons.azureWorkloadIdentity.isEnabled`);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Divider orientation="left" orientationMargin={0}>
        Add-On | Azure Workload Identity
      </Divider>
      <div id={`addon-azureWorkloadIdentity`} style={{ scrollMarginTop: 200 }}>
        <CpFormItem>
          <CpLabel name={"addons.azureWorkloadIdentity.tenantId"}>Tenant ID</CpLabel>
          <CpInput name={"addons.azureWorkloadIdentity.tenantId"} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={"addons.azureWorkloadIdentity.tenantId"} />
        </CpFormItem>
      </div>
    </>
  );
};
